import { render, staticRenderFns } from "./Defaults.vue?vue&type=template&id=953d01a0"
import script from "./Defaults.vue?vue&type=script&lang=js"
export * from "./Defaults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports